import type { RouteRecordRaw } from "vue-router";
import ChipView from "./views/ChipView.vue";
import PeripheralView from "./views/PeripheralView.vue";
import RegisterView from "./views/RegisterView.vue";
import SearchView from "./views/SearchView.vue";

export const routes: RouteRecordRaw[] = [
  { path: "/", name: "search", component: SearchView },
  { path: "/releases/:release/chips/:entity", name: "chip", component: ChipView },
  {
    path: "/releases/:release/peripherals/:entity",
    name: "peripheral",
    component: PeripheralView,
  },
  {
    path: "/releases/:release/registers/:entity(.*)",
    name: "register",
    component: RegisterView,
  },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];
